// This re-export-block is automatically generated, to customize, simply remove the block.
export * from '@mui/x-charts/locales';
// End of re-export-block
